import React from 'react';
import { findDOMNode } from 'react-dom';
import Base from 'client/components/base';
import Acast from 'client/components/common/button-acast';
import Loader from 'client/components/common/loader';
import autobind from 'autobind-decorator';
import { Query } from 'acast-reactor';
import _ from 'underscore';

const ACASTS_PER_PAGE = 10,
  ACAST_DESKTOP_COLUMNS = 2,
  ACAST_MOBILE_COLUMNS = 1,
  SMALL_WINDOWN_SIZE = 750;

@Query.inject(props => {
  return {
    query: Query.run('GetAcastsByChannel', props.channel, props.page || 0),
  };
})
export default class AcastList extends Base {
  constructor(props) {
    super(props);

    let acasts = props.acasts || props.query.value || [];
    this.state = {
      acasts: acasts.concat([]),
      screenWidth: typeof window !== 'undefined' ? window.innerWidth : -1,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  componentWillReceiveProps(newProps) {
    if (this.propsDidChange(newProps)) {
      // if we're searching into a new channel
      // we need to clean up
      if (newProps.channel !== this.props.channel) {
        this.setState({
          acasts: [],
        });
        // if we're getting new props, this means
        // we've gotten new acasts from a new query
      } else if (newProps.query) {
        if (newProps.query.isComplete) {
          let acasts = newProps.acasts || newProps.query.value || [];

          this.setState({
            acasts: this.mergeResults(this.state.acasts, acasts),
          });

          if (acasts.length < ACASTS_PER_PAGE && this.props.onAllLoaded) {
            this.props.onAllLoaded();
          } else if (this.props.onLoaded) {
            this.props.onLoaded();
          }
        }
      }
    }
  }

  mergeResults(existing, incoming) {
    let combined = _.union(existing, incoming);
    let unique = _.unique(combined, false, (item, key, id) => {
      return item.id;
    });

    return unique;
  }

  @autobind
  onResize() {
    this.setState({
      screenWidth: typeof window !== 'undefined' ? window.innerWidth : -1,
    });
  }

  render() {
    if (!this.props.numColumns && this.state.screenWidth === -1) {
      return <div className={this.css()} />;
    } else {
      let numberOfCols =
        this.props.numColumns || this.state.screenWidth <= SMALL_WINDOWN_SIZE
          ? ACAST_MOBILE_COLUMNS
          : ACAST_DESKTOP_COLUMNS;
      let acastColumns = this.getColumns(numberOfCols);

      return <div className={this.css()}>{acastColumns}</div>;
    }
  }

  getColumns(numberOfCols) {
    numberOfCols = numberOfCols || 2;

    let acasts = this.getAcasts();
    let acastsChunked = [];
    for (var i = 0, j = acasts.length, col = 0; i < j; i++) {
      if (typeof acastsChunked[col] === 'undefined') {
        acastsChunked[col] = [];
      }

      acastsChunked[col].push(acasts[i]);

      col = col >= numberOfCols - 1 ? 0 : ++col;
    }

    let columns = [];
    let className = numberOfCols > 1 ? 'col' : '';
    acastsChunked.forEach(function(chunk, idx) {
      if (chunk.length > 0) {
        columns.push(
          <div key={idx} className={className}>
            {chunk}
          </div>
        );
      }
    });

    return columns;
  }

  getAcasts() {
    let acasts = [];

    this.state.acasts.forEach((acast, idx) => {
      acasts.push(<Acast key={idx} position={idx + 1} model={acast} />);
    });

    return acasts;
  }
}



// WEBPACK FOOTER //
// ./client/components/common/acast-list/acast-list.es6